import React, { Component, useEffect, useState } from 'react';
import SettingsView from './SettingsView';
import crmservices from '../../wsclient/crmservices';
import { getAppCfg, getLanguage, saveDataIntoAsyncStore } from '../../utils/common';
import i18n from '../../translations/i18n'
import Loading from '../../components/Loading';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';

function SettingsController(props) {

    

    const [showLoading, onShowLoading] = useState(false);
    const [currentLanguge, setCurrentLanguage] = useState(getLanguage("LANGUAGE"));
    const [sms_opt_out, setSmsOtpOut] = useState(false);
    const [email_opt_out, setEmailOtpOut] = useState(false);
    const [enable_switch, setEnableSwitch] = useState({
        email_opt_out: true,
        sms_opt_out: true,
        language:  true})

    const app_config = getAppCfg()
    const app_name = app_config && app_config.name ? app_config.name : null;
    
    useEffect(()=>{
        onLoadContact();
    },[])

    const onUpdateMarketingInformation = async(type, status) =>{
        if (!enable_switch[type]) {
            return;
        }
        setEnableSwitch(prevState =>({
            ...prevState,
            [type] : false
        }))
        if(type =='email_opt_out'){
            setEmailOtpOut(status);
        }
        else if(type=='sms_opt_out'){
            setSmsOtpOut(status);
        }
        try {
            await crmservices.contacts.updateContactConsents({ [type]: !status });
            try {
                let result = await crmservices.contacts.getContact();
                if (result.code === 'OK') {
                    let sms_opt_out = result.data.sms_opt_out ? false : true;
                    let email_opt_out = result.data.email_opt_out ? false : true;
                    setSmsOtpOut(sms_opt_out);
                    setEmailOtpOut(email_opt_out);
                    //await cache.setContact(result.data);
                }
            } catch (error) {
                console.log("load contact error:", error);
            }
        } catch (error) {
            console.log("on receive marketing exeption:", error);
        }
        setEnableSwitch(prevState =>({
            ...prevState,
            [type] : true
        }))
    }
    const onLoadContact = async() =>{
        onShowLoading(true);
        try {
            let result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                let sms_opt_out = result.data.sms_opt_out ? false : true;
                let email_opt_out = result.data.email_opt_out ? false : true;
                setSmsOtpOut(sms_opt_out);
                setEmailOtpOut(email_opt_out);
                //await cache.setContact(result.data);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
        onShowLoading(false);
    }
    const onChangeLanguage = async() =>{

        let language = "";
        if (currentLanguge == 'ENG') {
            language = "GR";
        } else {
            language = "ENG";
        }
        setCurrentLanguage(language)
        saveDataIntoAsyncStore('LANGUAGE', language);
        i18n.changeLanguage(language);
        crmservices.contacts.updateContactLanguage(language);
    }
    return (
        <div>
            <SettingsView
                showLoading={showLoading}
                open={props.open}
                onClose={props.onClose}
                email_opt_out={email_opt_out}
                sms_opt_out={sms_opt_out}
                app_name={app_name}
                onUpdateMarketingInformation={onUpdateMarketingInformation}
                onChangeLanguage={onChangeLanguage}
                currentLanguge={currentLanguge}
            />

        </div>
    );
}

export default SettingsController;